import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThreeDots = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 4,
	fill: "none",
	viewBox: "0 0 14 4",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M3.5 2a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM12 3.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
		clipRule: "evenodd"
	})
});
export default SvgThreeDots;
